// Markdown básico das respostas da IA (negrito, itálico, títulos, listas),
// montado como elementos React — nunca injeta HTML vindo do modelo.
function trechos(texto, chave) {
  const partes = []
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g
  let ultimo = 0
  let m
  let i = 0
  while ((m = re.exec(texto))) {
    if (m.index > ultimo) partes.push(texto.slice(ultimo, m.index))
    const t = m[0]
    if (t.startsWith('**')) partes.push(<strong key={`${chave}-${i}`}>{t.slice(2, -2)}</strong>)
    else if (t.startsWith('`')) partes.push(<code key={`${chave}-${i}`} style={{ background: 'var(--yrm-surface-3)', padding: '0 4px', borderRadius: 4 }}>{t.slice(1, -1)}</code>)
    else partes.push(<em key={`${chave}-${i}`}>{t.slice(1, -1)}</em>)
    ultimo = m.index + t.length
    i += 1
  }
  if (ultimo < texto.length) partes.push(texto.slice(ultimo))
  return partes
}

export default function Markdown({ texto }) {
  const linhas = String(texto || '').replace(/\r/g, '').split('\n')
  const blocos = []
  let lista = null
  const fecharLista = () => {
    if (lista) blocos.push(lista.ordenada
      ? <ol key={`l${blocos.length}`} style={{ margin: '4px 0 8px', paddingLeft: 20 }}>{lista.itens}</ol>
      : <ul key={`l${blocos.length}`} style={{ margin: '4px 0 8px', paddingLeft: 20 }}>{lista.itens}</ul>)
    lista = null
  }
  linhas.forEach((linha, n) => {
    const item = linha.match(/^\s*(?:[-*•]|(\d+)[.)])\s+(.*)$/)
    if (item) {
      const ordenada = Boolean(item[1])
      if (!lista || lista.ordenada !== ordenada) { fecharLista(); lista = { ordenada, itens: [] } }
      lista.itens.push(<li key={n} style={{ margin: '2px 0' }}>{trechos(item[2], n)}</li>)
      return
    }
    fecharLista()
    const titulo = linha.match(/^\s*#{1,4}\s+(.*)$/)
    if (titulo) blocos.push(<div key={n} style={{ fontWeight: 700, margin: '8px 0 4px' }}>{trechos(titulo[1], n)}</div>)
    else if (linha.trim()) blocos.push(<p key={n} style={{ margin: '0 0 6px' }}>{trechos(linha, n)}</p>)
  })
  fecharLista()
  return <div style={{ lineHeight: 1.55 }}>{blocos}</div>
}
